export default "__VITE_ASSET__zqpVdEjw__"